export default {
  data() {
    return {
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
      initialX: 0,
      initialY: 0,
      xOffset: 0,
      yOffset: 0,
      dragActive: false
    };
  },
  methods: {
    /**
     * 触摸开始事件处理函数
     *
     * @param e 事件对象
     */
    touchStart(e) {
      // 拖拽开始时，设置页面为透明
      document.body.style.background = 'transparent';
      const app = document.getElementById('app');
      // 设置页面为圆角
      app.style.borderRadius = '10px';
      // 页面开始拖动
      this.dragActive = true;
      // 计算鼠标按下时相当于页面的水平位置
      this.startX = e.touches[0].clientX - this.xOffset;
      // 计算鼠标按下时相当于页面的垂直位置
      this.startY = e.touches[0].clientY - this.yOffset;

      // 保存元素的当前位置信息=
      this.initialX = this.currentX; // this.currentX 表示元素当前的水平位置
      this.initialY = this.currentY; // this.currentY 表示元素当前的垂直位置
      this.$emit('dragActive', this.dragActive);
    },
    // 在拖拽的过程中，不断更新元素的位置，来跟随鼠标移动
    touchMove(e) {
      // 只有在拖拽的状态下，才执行后续的操作
      if (this.dragActive) {
        e.preventDefault(); // 组织浏览器的默认行为，防止在拖拽过程中出现不需要的滚动或其他效果
        this.currentX = e.touches[0].clientX - this.startX; // 得到元素左边缘的水平距离
        this.currentY = e.touches[0].clientY - this.startY; // 得到元素上边缘的垂直距离

        let scaleX = (window.innerWidth - this.currentX) / window.innerWidth || 1;
        const maxLeaveWidth = window.innerWidth * (1 / 6) || 20;
        // 拖拽时，如果距离左边小于1/6，则不缩放
        if (this.currentX < maxLeaveWidth) {
          scaleX = 1;
        } else {
          // 拖拽时，如果距离左边大于1/6时，开始缩放
          const currentLeftX = this.currentX - maxLeaveWidth;
          scaleX = (window.innerWidth - currentLeftX) / window.innerWidth;
        }
        if (scaleX < 0.5) {
          scaleX = 0.5;
        }
        if (scaleX >= 1) {
          scaleX = 1;
        }
        this.xOffset = this.currentX;
        this.yOffset = this.currentY;
        document.body.style.transform = `scale(${scaleX}) translate(${this.currentX}px, ${this.currentY}px)`;
      }
    },
    // 保存拖拽结束时元素的最终位置
    touchEnd(e) {
      const maxMoveX = window.innerWidth / 10 || 20;
      if (this.currentX < maxMoveX) {
        document.body.style.transform = 'scale(1)';
        document.body.style.background = '#f2f4f5';
      } else {
        this.$emit('touchDragEnd');
      }
      const app = document.getElementById('app');
      // 关闭页面重置border-radius
      app.style.borderRadius = 'initial';
      this.dragActive = false; // 表示拖拽操作已经结束，元素不再处于活动状态
      this.$emit('dragActive', this.dragActive);
      // 重置拖拽相关参数
      this.resetScreenPostion();
    },
    resetScreenPostion() {
      this.initialX = 0;
      this.initialY = 0;
      this.currentX = 0;
      this.currentY = 0;
      this.startX = 0;
      this.startY = 0;
      this.xOffset = 0;
      this.yOffset = 0;
      this.dragActive = false; // 表示拖拽操作已经结束，元素不再处于活动状态
    }
  }
};